"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactRouterDom = require("react-router-dom");

var _compose = _interopRequireDefault(require("ramda/src/compose"));

var _partial = _interopRequireDefault(require("ramda/src/partial"));

var _path = _interopRequireDefault(require("ramda/src/path"));

var _map = _interopRequireDefault(require("ramda/src/map"));

var _contexts = require("../../contexts");

var _utils = require("../../utils");

var _useNavigation = require("./useNavigation");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  activeStep: _propTypes.string,
  onChange: _propTypes.func,
  children: _propTypes.node.isRequired
} : {};
const defaultProps = {
  onChange: () => null
};
const stepsToPath = (0, _map.default)((0, _compose.default)((0, _partial.default)(_utils.addPrefix, '/'), (0, _path.default)(['props', 'name'])));

const Stepper = ({
  activeStep,
  onChange,
  children
}) => {
  const steps = stepsToPath(_react.default.Children.toArray(children));
  const {
    history,
    ...navigationProps
  } = (0, _useNavigation.useNavigation)({
    steps,
    activeStep,
    onChange
  });
  const contextProps = {
    steps,
    history,
    ...navigationProps
  };
  return (0, _core.jsx)(_contexts.StepperContext.Provider, {
    value: contextProps
  }, (0, _core.jsx)(_reactRouterDom.Router, {
    history: history
  }, children));
};

exports.Stepper = Stepper;
process.env.NODE_ENV !== "production" ? Stepper.propTypes = propTypes : void 0;
Stepper.defaultProps = defaultProps;
Stepper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Stepper",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activeStep": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};